enum EStatus {
    IDLE,
    LOADING,
    SUCCESS,
    ERROR
}

export default EStatus;